import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["tracker"];
import { useCallback } from 'react';
import { useUsageTrackerContext } from 'personalization-lib/contexts/UsageTrackerContext';
import { LIBRARY_EVENT_NAMESPACE } from 'personalization-lib/constants/tracking/libEvents';
const useLibTracker = eventName => {
  const _useUsageTrackerConte = useUsageTrackerContext(),
    {
      tracker
    } = _useUsageTrackerConte,
    defaultProperties = _objectWithoutPropertiesLoose(_useUsageTrackerConte, _excluded);
  return useCallback(properties => tracker === null || tracker === void 0 ? void 0 : tracker.track(LIBRARY_EVENT_NAMESPACE, eventName, Object.assign({}, properties, defaultProperties)), [tracker, eventName, defaultProperties]);
};
export default useLibTracker;